import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ToastrService, ProjectService } from './../../../../shared/index';
import { Subscription } from 'rxjs';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'Snapshot-list',
    templateUrl: './Snapshot-list.html',
    standalone: false
})
export class SnapshotListComponent implements OnInit, OnDestroy {
    public SnapShoDatetLst: any[] = [];
    public subscriptions: Subscription[] = [];
    @ViewChild('Snapshot') modal: ModalDirective;
    Date = '';
    textColor: string | string[] | { [klass: string]: boolean } = '';
    constructor(
        private _toastrService: ToastrService,
        private _ProjectService: ProjectService
    ) {}
    ngOnInit(): void {
        for (let i = 1; i < 15; i++) {
            const now = new Date();
            now.setDate(now.getDate() - i);
            const days = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday');
            const months = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December');

            const date = ((now.getDate() < 10) ? '0' : '') + now.getDate();
            this.SnapShoDatetLst.push({ 'Date': days[now.getDay()] + ', ' + months[now.getMonth()] + ' ' + date + ', ' + (this.fourdigits(now.getFullYear()))
            });
        }
    }
    fourdigits(number: any) {
        return (number < 1000) ? number + 1900 : number;
    }
    ngOnDestroy(): void {
    }
    public ShowModal(val: any): void {
        this.Date = val;
        this.modal.show();
    }
    public Restore() {
        const temp = this.SnapShoDatetLst[13].Date;
        return this._ProjectService.SnapShot_Restore(this.Date, temp).then((result: any) => {
            if (result) {
                this._toastrService.displayToastrMessage('success', 'Snap Shot restore to date ' + this.Date + ' successfully', 'Snap Shot!');
                this.modal.hide();
            } else {
                this._toastrService.displayToastrMessage('error', 'Error occured while processing your request', 'Snap Shot!')
            }
        });
    }
    public Close() {
        this.modal.hide();
    }
}
